// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"AnchorWithArrow_wrapper__aLbeF","positionLeft":"AnchorWithArrow_positionLeft__K1q1i","positionRight":"AnchorWithArrow_positionRight__gQafu"};